/**
 * graph004
 * TYPE: '' or 'g4-w' or 'g4-m'
 */
export default class {

	constructor(selector, data, type) {
		this.ID = selector;
		this.DATA = this.buildData(data);
		this.TYPE = type;

		// objects
		this.graph;

		// init
		this.buildGraph();
	}

	buildData(data) {
		// To Date Object
		for(var k in data.x) {
			data.x[k] = new Date(data.x[k]);
		}

		switch(this.TYPE) {
			case 'g4-w':
				return {
					axisXtype: 'timeseries',
					axisXLabelFormat: '%m-%d',// 'month-day',
					axisXcullingMax: 0,
					good: data.good,
					normal: data.normal,
					bad: data.bad,
					x: data.x,
					max: data.max
				}; // _2
				break;

			case 'g4-m':
				return {
					axisXtype: 'timeseries', //'category',
					axisXLabelFormat: '%Y-%m',// 'year-month',
					axisXcullingMax: 0,
					good: data.good,
					normal: data.normal,
					bad: data.bad,
					x: data.x,
					max: data.max
				}; // _3
				break;

			default:
				return {
					axisXtype: 'timeseries',
					axisXLabelFormat: '%m-%d', //'month/day',
					axisXcullingMax: 16,
					good: data.good,
					normal: data.normal,
					bad: data.bad,
					x: data.x,
					max: data.max
				}; // _1
				break;
		}
	}

	buildGraph(notAddEvent) {
		if(!$(this.ID).length) return false;

		this.graph = this.Graph004(this.ID, this.DATA, this.TYPE);
//		$(this.ID).data('c3-chart', this.graph);

//		if(!notAddEvent) this.graphResize(); // add resize event
	}

	// Resize graph
	graphResize() {
		// Resize
		window.addEventListener("resize", function(){
			if($(window).width() > 319){
				if($(this.ID).data('c3-chart')) return;
				this.buildGraph(true);
				return;
			}

			if(!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))){
				this.buildGraph(true);
				return;
			}
			return false;
		}.bind(this));

		// Resize graph on print
		window.matchMedia("print").addListener(function() {
			if($('body').hasClass("is-modal--white-print")) return false;

			if($(this.ID).is(":visible")) this.graph.resize();
		}.bind(this));
	}

	Graph004(id, dataG004, g4Type) {
		// color
		var dataColorG004 = {
			good: '#13C959',
			normal: '#FDB900',
			bad: '#FF009D',
			column: 'transparent'
		};

		// Label
		var labelGood = "推奨者",
			labelNormal = "中立者",
			labelBad = "批判者";

		// data
		var jsonData = {
			good : dataG004.good,
			normal: dataG004.normal,
			bad: dataG004.bad,
			column: dataG004.good,
			x: dataG004.x
		};

		var chart = c3.generate({
			bindto: id,
			data: {
				x: 'x',
				json: jsonData,
				types: {
					good: 'line',
					normal: 'line',
					bad: 'line',
					column: 'bar'
				},
				colors: dataColorG004
			},
			size: { height: 230 },
			padding: { top: 20, left: 0, bottom: 0 },
			bar: { width: 0 },
			grid: {
				lines: { front: false },
				y: {
					show: false,
					lines: function () {
						/*draw line and text in graph*/
						return [
							{ value: Math.round(dataG004.max * 0.8), class: 'grid ', text: Math.round(dataG004.max * 0.8) + '票', position: 'start' },
							{ value: Math.round(dataG004.max * 0.4), class: 'grid', text: Math.round(dataG004.max * 0.4) + '票', position: 'start' },
							{ value: 0, class: 'gridfoot2' }
						];
					},
				}
			},
			legend: { show: false },
			axis: {
				x: {
					tick: {
						outer: false,
						multiline: false,
						culling: { max: dataG004.axisXcullingMax },
						format: dataG004.axisXLabelFormat
					},
					type: dataG004.axisXtype,
					label: {
						text: '',
						position: "outer-left"
					}
				},
				y: {
					tick: { outer: false },
					max: dataG004.max,
					min: 0,
					padding: { top: 0, bottom: 2 },
					label: {
						text: '',
						position: 'inner-bottom'
					}
				}
			},
			point: { r: 4 },
			tooltip: {
				contents: function(d, defaultTitleFormat, defaultValueFormat, color) {
					var labels = {
						good: labelGood,
						normal: labelNormal,
						bad: labelBad
					};

					var txt = '<table class="c3-tooltip c3-tooltip-container"><tr><th colspan="2">' + defaultTitleFormat(d[0].x) + '</th></tr>';
					for(var k in d) {
						if(d[k].name == 'column') continue;
						var bgcolor = this.levelColor ? this.levelColor(d[k].value) : color(d[k].id);
						txt += '<tr class="' + d[k].id + '">';
						txt += '<td class="name"><span style="background-color:' + bgcolor + '"></span>' + labels[d[k].name] + '</td>';
						txt += '<td class="value">' + defaultValueFormat(d[k].value) + '</td></tr>';
					}
					return txt + '</table>';
				}
			},
			onrendered: function() {

				var graphWidth = parseInt(d3.select(id + ' .c3-event-rect').attr('width'));

				var axis = d3.selectAll("" + id + " .c3-axis-x");
				axis.attr("transform", "translate(0,0)");

				var tick = axis.selectAll(".tick");
				var tickText = axis.selectAll(".tick text");

				var tickShow = [];
				tickText.filter(function(d, i) {
					if(d3.select(this).style('display') != 'block') return;
					tickShow.push(d3.select(this));
				});

				if(tickShow.length > 3) {
					// Detect First Tick
					var firstTransformValue = d3.select(tickShow[0].node().parentNode).attr('transform');
					var firstTranslateX = firstTransformValue.replace(/[^\d,.]/g, '').split(',')[0];

					var secondTransformValue = d3.select(tickShow[1].node().parentNode).attr('transform');
					var secondTranslateX = parseInt(secondTransformValue.replace(/[^\d,.]/g, '').split(',')[0]);

					var lastTransformNode = d3.select(tickShow[tickShow.length / 2 - 1].node().parentNode);
					var lastTransformValue = lastTransformNode.attr('transform');
					var lastTranslateX = parseInt(lastTransformValue.replace(/[^\d,.]/g, '').split(',')[0]);

					var nextLastTransformNode = d3.select(tickShow[tickShow.length / 2 - 2].node().parentNode).attr('transform');
					var nextLastTranslateX = parseInt(nextLastTransformNode.replace(/[^\d,.]/g, '').split(',')[0]);

					var tickWidth = tickShow[0].node().getBoundingClientRect().width / 2;
					var lastTickWidth = tickShow[tickShow.length / 2 - 1].node().getBoundingClientRect().width;
					var nextLastTickWidth = tickShow[tickShow.length / 2 - 2].node().getBoundingClientRect().width;

					//Move first tick to x=0
					if(firstTranslateX < tickWidth) tickShow[0].select('tspan').attr('dx', (tickWidth - firstTranslateX));
					//Hide First tick when this tick over the next tick
					if(tickWidth > secondTranslateX) tickShow[0].select('tspan').attr('style', 'display: none');
					// Move the last tick to x = graph width
					if((lastTranslateX + lastTickWidth /2) > graphWidth) lastTransformNode.attr('transform', 'translate(' + (graphWidth - lastTickWidth / 2) + ', 0)');
					//Hide Last tick when this tick over the next last tick
					if((nextLastTranslateX + nextLastTickWidth / 2 + lastTickWidth) > graphWidth) tickShow[tickShow.length / 2 - 1].select('tspan').attr('style', 'display: none');
				}

				$('.c-graph-004 > p').css('visibility', 'visible');

			}
		});

		d3.select(id).insert('div', '.chart').attr('class', 'c-legend').selectAll('span')
			.data(['good', 'normal', 'bad'])
			.enter().append('span')
			.attr('data-id', function(id) { return id; })
			.html(function(id) { return id; })
			.on('mouseover', function(id) { chart.focus(id); })
			.on('mouseout', function(id) { chart.revert(); })
			.on('click', function(id) { chart.toggle(id); });

		d3.select('' + id + ' span[data-id="good"]').html('<svg class="svg-face_good-dims"><use xlink:href="/assets/img/shared/sprite.symbol.svg#face_good"></use></svg>' + labelGood + '');
		d3.select('' + id + ' span[data-id="normal"]').html('<svg class="svg-face_normal-dims"><use xlink:href="/assets/img/shared/sprite.symbol.svg#face_normal"></use></svg>' + labelNormal + '');
		d3.select('' + id + ' span[data-id="bad"]').html('<svg class="svg-face_bad-dims"><use xlink:href="/assets/img/shared/sprite.symbol.svg#face_bad"></use></svg>' + labelBad + '');

		return chart;
	}
}
